import { render, staticRenderFns } from "./UploadImageIcon.vue?vue&type=template&id=41642980&"
import script from "./UploadImageIcon.vue?vue&type=script&lang=js&"
export * from "./UploadImageIcon.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports